
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/omnichannel/kectypes",
      function () {
        return require("private-next-pages/india/omnichannel/kectypes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/omnichannel/kectypes"])
      });
    }
  